// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"871":"important_message","962":"home"}[chunkId] + "." + {"871":"816822e3","962":"e3c15c63"}[chunkId] + ".css";
};